module.exports = __webpack_public_path__ + "static/media/logo-ana-sidebar-home.93fe9cac.png";